<template>
    <div class="msp-valutazione-allenamento-mobile">
    <msp-valutazione @update="select" :readonly="readonly" :init-value="initValue"></msp-valutazione></div>
</template>

<script>
import _api from "@mixins/api.js";
import mspValutazione from "./MspValutazione.vue"
const component = {
    components: {
        mspValutazione,
    },
    props: [
        'calendario-id',
        'init-value',
        'readonly',

    ],
    methods: {
        makeData: function (valutazione) {
            const data = {
                calendario_id: this.calendarioId,
                valutazione: valutazione,
            };

            return data;
        },

        save: function (valutazione) {
            const data = this.makeData(valutazione);
            const url =  process.env.VUE_APP_API_BASE_URL + "/api/v2/feedback.php";

            return _api(url, "POST", data)
        },

        select: async function ({valutazione}) {
            this.selected = valutazione;
            this.loading = true;
            const result = await this.save(valutazione); 
            this.loading = false;
            if (result.status !== 201) return;
            if (result.success) {
                const data = this.makeData(valutazione);
                this.$emit("update", data);
            }
        }
    },
}
export default component;
</script>

<style lang="scss">
.msp-valutazione-allenamento-mobile {
    text-align: center;
    padding: 0 20px;
    .valutazione-dettaglio {
        display: grid;
        grid-template-columns: 1fr auto;
        align-content: center;
        img {
            height: 40px;
            align-self: center;
        }
        &.placeholder {
            opacity: 0.2;
            img {
                filter: grayscale(1);
            }
        }

    }
}
</style>
